export default __webpack_public_path__ + "static/media/vlad-suciu.be9faf9e.png";